import { Skeleton, Card } from "antd";

import styles from "./StatsItemSkeleton.module.scss";

export const StatsItemSkeleton = () => {
  return (
    <Card className={styles.card}>
      <Skeleton paragraph={{ rows: 2 }} />
    </Card>
  );
};
